// extracted by mini-css-extract-plugin
export default {"slot":"bookingSlot_slot__hphbk","slotTitle":"bookingSlot_slotTitle__pIR3j","slotPrice":"bookingSlot_slotPrice__BWgay"};